<!-- main container for arrival / departure details-->
<div class="border-style border rounded-2xl p-6 bg-white flex gap-4 flex-col">

  <div class="flex gap-4">
    <div
      class="w-11 h-11 p-1 bg-blue-700 rounded-full border-8 border-sky-100 flex-col justify-center items-center gap-2.5 inline-flex">
      <div class="text-white text-base font-bold  leading-none">
        @if(type === 'departure') {
        <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M1.51937 15.7149H20.5194V17.7149H1.51937V15.7149ZM21.0894 6.35491C20.8794 5.55491 20.0494 5.07491 19.2494 5.29491L13.9394 6.71491L7.01937 0.284912L5.10938 0.794912L9.24937 7.96491L4.27938 9.29491L2.30937 7.75491L0.859375 8.14491L2.67938 11.3049L3.44937 12.6349L5.04938 12.2149L10.3594 10.7849L14.7094 9.62491L20.0194 8.21491C20.8294 7.97491 21.2994 7.15491 21.0894 6.35491Z"
            fill="white" />
        </svg>
        }
        @if(type === 'arrival') {
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0.5 17.5H19.5V19.5H0.5V17.5ZM7.68 11.77L12.03 12.93L17.34 14.35C18.14 14.56 18.96 14.09 19.18 13.29C19.39 12.5 18.92 11.67 18.12 11.45L12.81 10.03L10.05 1L8.12 0.5V8.78L3.15 7.45L2.22 5.13L0.77 4.74V9.91L2.37 10.34L7.68 11.77Z"
            fill="white" />
        </svg>
        }
      </div>
    </div>
    <div class="
          self-center
          text-black text-xl font-bold  leading-none">
      @if(type === 'departure') {
      {{"PARKIFLY.SEARCH.DEPARTURE_HEADING" | transloco}}
      }
      @if(type === 'arrival') {
      {{"PARKIFLY.SEARCH.ARRIVAL_HEADING" | transloco}}
      }
    </div>
  </div>

  @if (type === 'departure') {
  <div class="
    flex 
    gap-4
    ">
    <!-- Switch/Toggle -->
    <div class="relative  inline-block">
      <input (change)="toggleHotel($event)" type="checkbox" [checked]="showHotel" id="hs-default-switch-with-icons"
        class="peer relative w-[3.25rem] h-7 p-px bg-gray-100 border-transparent text-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:ring-blue-600 disabled:opacity-50 disabled:pointer-events-none checked:bg-none checked:text-toggle-success checked:border-toggle-success focus:checked:border-blue-600 dark:bg-neutral-800 dark:border-neutral-700 dark:checked:bg-blue-500 dark:checked:border-blue-500 dark:focus:ring-offset-gray-600
        
            before:inline-block before:size-6 before:bg-white checked:before:bg-white before:translate-x-0 checked:before:translate-x-full before:rounded-full before:shadow before:transform before:ring-0 before:transition before:ease-in-out before:duration-200 dark:before:bg-neutral-400 dark:checked:before:bg-blue-200">
      <label for="hs-default-switch-with-icons" class="sr-only">switch</label>
      <span
        class="peer-checked:text-white text-gray-500 size-6 absolute top-0.5 start-0.5 flex justify-center items-center pointer-events-none transition-colors ease-in-out duration-200 dark:text-neutral-500">
        <svg class="flex-shrink-0 size-3" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M18 6 6 18"></path>
          <path d="m6 6 12 12"></path>
        </svg>
      </span>
      <span
        class="peer-checked:text-success text-gray-500 size-6 absolute top-0.5 end-0.5 flex justify-center items-center pointer-events-none transition-colors ease-in-out duration-200 dark:text-neutral-500">
        <svg class="flex-shrink-0 size-3" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      </span>
    </div>
    <p class="self-center font-medium text-sm leading-none break-words">
      {{type === 'arrival' ? ("QUALITY_HOTEL.HOTEL_ARRIVAL_TOGGLE_LABEL" | transloco: {hotelName: hotelName}) :
      ("QUALITY_HOTEL.HOTEL_DEPARTURE_TOGGLE_LABEL" | transloco: {hotelName: hotelName})}}
    </p>
  </div>
  }

  <!-- radio button by flight or by time -->
  @if (type === 'arrival') {
  <div class="flex gap-4 mt-2">
    <div class="flex items-center">
      <input type="radio" id="byFlight" name="arrivalMode" (change)="toggleByFlightOrByTime()" [value]="true"
        [(ngModel)]="useFlightForArrival" class="mr-2">
      <label for="byFlight" class="font-medium text-sm">{{'QUALITY_HOTEL.BY_FLIGHT' | transloco}}</label>
    </div>
    <div class="flex items-center">
      <input type="radio" id="byTime" name="arrivalMode" (change)="toggleByFlightOrByTime()" [value]="false"
        [(ngModel)]="useFlightForArrival" class="mr-2">
      <label for="byTime" class="font-medium text-sm">{{'QUALITY_HOTEL.BY_TIME' | transloco}}</label>
    </div>
  </div>
  }

  <!-- selectors container-->
  <div class="
    flex
    flex-col
    lg:flex-row  
    h-auto
    lg:h-[80px]
    py-[15px]
    lg:border
    lg:border-[#AAAAAA]
    rounded-[5px];
    lg:rounded-[16px]
    gap-1
    ">

    @if(showHotel) {
    <!-- hotel time select-->
    <div (click)="openHotelDateTimeDialog('parking')"
      class="flex-1 cursor-pointer py-4 px-4 lg:py-0 lg:px-0 lg:pl-6 border-style rounded-[16px] border lg:border-none">
      <div class="flex w-full gap-2">
        <div class="min-w-0">
          <p class="font-bold text-primary-blue text-sm pb-2 break-words">
            {{ type === 'departure' ? ( "PARKIFLY.DATE_AND_FLIGHT_PICKER.SELECT_HOTEL_DEPARTURE_LABEL" |
            transloco ): "PARKIFLY.DATE_AND_FLIGHT_PICKER.SELECT_HOTEL_ARRIVAL_LABEL" |transloco }}
          </p>
          <p class="text-sm break-words" [ngClass]="{'text-[#717171]': !selectedHotelDate}">
            @if(selectedHotelDate) {
            {{selectedHotelDate | date : 'yyyy-MM-dd' }}
            {{' ' + ("PARKIFLY.CLOCK_SHORT" | transloco)}}:
            {{selectedHotelDate | date : 'HH:mm' }}
            }@else {
            {{type === 'arrival'
            ? ("PARKIFLY.DATE_AND_FLIGHT_PICKER.SELECT_HOTEL_ARRIVAL_TIME_PLACEHOLDER" | transloco)
            : ("PARKIFLY.DATE_AND_FLIGHT_PICKER.SELECT_HOTEL_DEPARTURE_TIME_PLACEHOLDER" | transloco)
            }}
            }
          </p>
        </div>
      </div>
    </div>

    <div class="border-l gap- border-color-gray"></div>

    @if(type === 'departure') {
    <div [matMenuTriggerFor]="passengersMenuForDeparture"
      class="flex-1 cursor-pointer py-4 px-4 lg:py-0 lg:px-0 lg:pl-6 border-style rounded-[16px] border lg:border-none"
      [ngClass]="{
                'pointer-events-none' : (!showHotel ? !selectedDate : !selectedHotelDate),
                'cursor-not-allowed' : (!showHotel ? !selectedDate : !selectedHotelDate)
                }">
      <div class="flex w-full gap-2">
        <div class="min-w-0">
          <p [ngClass]="{'text-[#ADADAD]' : (!showHotel ? !selectedDate : !selectedHotelDate), 'text-primary-blue' : (!showHotel ? selectedDate : selectedHotelDate)}"
            class="font-bold text-sm pb-2 break-words">
            {{ "FORM.PASSENGERS_LABEL" | transloco }}
          </p>
          <p class="text-sm break-words" [ngClass]="{'text-[#ADADAD]': !selectedPassengers}">
            @if(selectedPassengers) {
            @if(selectedPassengers == 1) {
            {{selectedPassengers}} {{'QUALITY_HOTEL.PASSENGER' | transloco}}
            } @else {
            {{selectedPassengers}} {{'QUALITY_HOTEL.PASSENGERS' | transloco}}
            }
            }@else {
            {{ "FORM.PASSENGERS_PLACEHOLDER" | transloco }}
            }
          </p>
        </div>
      </div>
    </div>
    <mat-menu #passengersMenuForDeparture="matMenu" class="h-full max-h-80 max-width-initial">
      @for (num of passengerOptions; track $index) {
      <button mat-menu-item (click)="setPassengers(num)">
        @if(num == 1){
        <span>{{num}} {{'QUALITY_HOTEL.PASSENGER' | transloco}}</span>
        } @else{
        <span>{{num}} {{'QUALITY_HOTEL.PASSENGERS' | transloco}}</span>
        }
      </button>
      }
    </mat-menu>

    <div class="border-l gap- border-color-gray"></div>
    }

    <div (click)="openHotelDateTimeDialog('depTransfer')"
      class="flex-1 cursor-pointer py-4 px-4 lg:py-0 lg:px-0 lg:pl-6 border-style rounded-[16px] border lg:border-none"
      [ngClass]="{
                'pointer-events-none' : !selectedPassengers,
                'cursor-not-allowed' : !selectedPassengers
                }">
      <p [ngClass]="{'text-[#ADADAD]' : !selectedPassengers, 'text-primary-blue' : selectedPassengers}"
        class="font-bold text-primary-blue text-sm pb-2 break-words">
        {{ "FORM.TRANSFER_DATETIME_LABEL" | transloco }}
      </p>
      <p class="text-sm break-words" [ngClass]="{'text-[#ADADAD]': !selectedDepartureDateForTransfer}">
        @if(selectedDepartureDateForTransfer) {
        {{selectedDepartureDateForTransfer | date : 'yyyy-MM-dd' }}
        {{' ' + ("PARKIFLY.CLOCK_SHORT" | transloco)}}:
        {{selectedDepartureDateForTransfer | date : 'HH:mm' }}
        }@else {
        {{ "FORM.TRANSFER_DATETIME_PLACEHOLDER" | transloco }}
        }
      </p>
    </div>

    <div class="border-l gap- border-color-gray"></div>

    <div [matMenuTriggerFor]="shuttleBusTimeForHotel"
      class="flex-1 cursor-pointer py-4 px-4 lg:py-0 lg:px-0 lg:pl-6 border-style rounded-[16px] border lg:border-none"
      [ngClass]="{
                'pointer-events-none' : !selectedDepartureDateForTransfer,
                'cursor-not-allowed' : !selectedDepartureDateForTransfer
                }" (click)="fetchDepShuttleBusses('departure')">
      <p [ngClass]="{'text-[#ADADAD]' : !selectedDepartureDateForTransfer, 'text-primary-blue' : selectedDepartureDateForTransfer}"
        class="font-bold text-sm pb-2 break-words">
        {{"FORM.PICKUPTIME" | transloco}}
      </p>
      <p class="text-sm break-words" [ngClass]="{'text-[#ADADAD]': !selectedShuttleBusDeparture}">
        @if(selectedShuttleBusDeparture) {
        {{selectedShuttleBusDeparture.startDate | date: 'yyyy-MM-dd'}}
        {{' ' + ("PARKIFLY.CLOCK_SHORT" | transloco)}}: {{selectedShuttleBusDeparture.startDate | date:
        'HH:mm'}}
        }@else {
        {{"FORM.PICKUP_TIME_PLACEHOLDER" | transloco}}
        }
      </p>
    </div>
    <mat-menu #shuttleBusTimeForHotel="matMenu" class="h-full max-h-80 max-width-initial">
      @for (route of plannedShuttleBussesDeparture; track $index) {
      <button mat-menu-item (click)="setShuttleBus(route, 'departure')">
        <div class="display-flex">
          <span>{{("PARKIFLY.CLOCK_SHORT" | transloco)}}: {{route.startDate | date: 'HH:mm'}}</span>
          <div class="width-5"></div>
          @if (route.seats != null) {
          <span>{{'QUALITY_HOTEL.AVAILABLE_SPOTS' | transloco}}({{(route.seats -
            route.passengers)}})</span>
          }
        </div>
      </button>
      }
    </mat-menu>

    <div class="border-l gap- border-color-gray"></div>

    @if ((type == 'departure' && showHotel == true)) {
    <div [matMenuTriggerFor]="terminalMenu"
      class="flex-1 cursor-pointer py-4 px-4 lg:py-0 lg:px-0 lg:pl-6 border-style rounded-[16px] border lg:border-none"
      [ngClass]="{
                'pointer-events-none' : !selectedShuttleBusDeparture,
                'cursor-not-allowed' : !selectedShuttleBusDeparture
                }">
      <p class="font-bold text-sm pb-2 break-words"
        [ngClass]="{'text-[#ADADAD]' : !selectedShuttleBusDeparture, 'text-primary-blue' : selectedShuttleBusDeparture}">
        {{ "FORM.TERMINAL_LABEL" | transloco }}
      </p>
      <p class="text-sm break-words" [ngClass]="{'text-[#ADADAD]': !selectedTerminal}">
        @if(selectedTerminal) {
        {{selectedTerminal.terminalName}}
        }@else {
        {{ "FORM.TERMINAL_PLACEHOLDER" | transloco }}
        }
      </p>
    </div>
    }
    <mat-menu #terminalMenu="matMenu" class="h-full max-h-80 max-width-initial">
      @for (terminal of departureTerminals; track $index) {
      <button mat-menu-item (click)="setTerminal(terminal)">
        <span>{{terminal.terminalName}}</span>
      </button>
      }
    </mat-menu>

    }

    @if(!showHotel) {
    <div (click)="openDateDialog()"
      class="flex-1 cursor-pointer py-4 px-4 lg:py-0 lg:px-0 lg:pl-6 border-style rounded-[16px] border lg:border-none">
      <p class="font-bold text-primary-blue text-sm pb-2 break-words">
        {{type == 'arrival' ?
        ("QUALITY_HOTEL.RETURN_DATE" | transloco)
        : ("PARKIFLY.DATE_AND_FLIGHT_PICKER.SELECT_FLIGHT_DEPARTURE_DATE_LABEL" | transloco) }}
      </p>
      <p class="text-sm break-words" [ngClass]="{'text-[#717171]' : !selectedDate}">
        {{ selectedDate
        ? (selectedDate | date: 'yyyy-MM-dd')
        : (type === 'arrival'
        ? ("PARKIFLY.DATE_AND_FLIGHT_PICKER.SELECT_FLIGHT_ARRIVAL_DATE_PLACEHOLDER" | transloco)
        : ("PARKIFLY.DATE_AND_FLIGHT_PICKER.SELECT_FLIGHT_DEPARTURE_DATE_PLACEHOLDER") | transloco)
        }}
      </p>
    </div>

    <div class="border-l gap- border-color-gray"></div>

    @if(type == 'departure'){
    <!-- Passengers selector -->
    <div [matMenuTriggerFor]="passengersMenu"
      class="flex-1 cursor-pointer py-4 px-4 lg:py-0 lg:px-0 lg:pl-6 border-style rounded-[16px] border lg:border-none"
      [ngClass]="{
                'pointer-events-none' : !(showHotel ? selectedHotelDate : selectedDate),
                'cursor-not-allowed' : !(showHotel ? selectedHotelDate : selectedDate)
                }">
      <div class="flex w-full gap-2">
        <div class="min-w-0">
          <p [ngClass]="{'text-[#ADADAD]' : !(showHotel ? selectedHotelDate : selectedDate), 'text-primary-blue' : selectedDate}"
            class="font-bold text-sm pb-2 break-words">
            {{"FORM.PASSENGERS_LABEL" | transloco}}
          </p>
          <p class="text-sm break-words"
            [ngClass]="{'text-[#ADADAD]': !selectedPassengers, 'text-black': selectedPassengers}">
            @if(selectedPassengers) {
            @if(selectedPassengers == 1) {
            {{selectedPassengers}} {{'QUALITY_HOTEL.PASSENGER' | transloco}}
            } @else {
            {{selectedPassengers}} {{'QUALITY_HOTEL.PASSENGERS' | transloco}}
            }
            }@else {
            {{ "FORM.PASSENGERS_PLACEHOLDER" | transloco }}
            }
          </p>
        </div>
      </div>
    </div>
    <mat-menu #passengersMenu="matMenu" class="h-full max-h-80 max-width-initial">
      @for (num of passengerOptions; track $index) {
      <button mat-menu-item (click)="setPassengers(num)">
        @if(num == 1){
        <span>{{num}} {{'QUALITY_HOTEL.PASSENGER' | transloco}}</span>
        } @else{
        <span>{{num}} {{'QUALITY_HOTEL.PASSENGERS' | transloco}}</span>
        }
      </button>
      }
    </mat-menu>

    <div class="border-l gap- border-color-gray"></div>
    }

    <!-- flight selector-->
    @if ((type == 'arrival' && useFlightForArrival == true) || (type == 'departure')) {
    <div
      class="flex-1 cursor-pointer py-4 px-4 lg:py-0 lg:px-0 lg:pl-6 border-style rounded-[16px] border lg:border-none"
      (click)="openFlightDialog()" [ngClass]="{'!cursor-not-allowed' : !(type === 'departure' ? selectedPassengers : selectedDate),
            'pointer-events-none' : !(type === 'departure' ? selectedPassengers : selectedDate)}">
      <p [ngClass]="{'text-[#ADADAD]' : !(type === 'departure' ? selectedPassengers : selectedDate), 'text-primary-blue' : (type === 'departure' ? selectedPassengers : selectedDate)}"
        class="font-bold text-primary-blue text-sm pb-2 break-words">
        {{"PARKIFLY.DATE_AND_FLIGHT_PICKER.SELECT_FLIGHT" | transloco}}
      </p>
      <p class="text-sm break-words"
        [ngClass]="{'text-[#ADADAD]' : !(type === 'departure' ? selectedPassengers : selectedDate), 'text-black' : selectedFlight, 'text-[#717171]' : !selectedFlight}">
        @if(selectedFlight) {
        {{selectedFlight.flightId}} |
        {{type == 'arrival' ? selectedFlight.departureAirportEnglish: selectedFlight.arrivalAirportEnglish
        }}
        |
        {{type == 'arrival' ? ( selectedFlight.arrivalTime.scheduled | date : 'HH:mm') :
        (selectedFlight.departureTime.scheduled | date : 'HH:mm')}}
        }@else {
        {{"PARKIFLY.DATE_AND_FLIGHT_PICKER.SELECT_FLIGHT_PLACEHOLDER" | transloco}}
        }
      </p>
    </div>
    }

    @if ((type == 'arrival' && useFlightForArrival == false)) {
    <div [matMenuTriggerFor]="terminalMenu"
      class="flex-1 cursor-pointer py-4 px-4 lg:py-0 lg:px-0 lg:pl-6 border-style rounded-[16px] border lg:border-none"
      [ngClass]="{'pointer-events-none' : !selectedDate, 'cursor-not-allowed' : !selectedDate}">
      <p class="font-bold text-sm pb-2 break-words"
        [ngClass]="{'text-[#ADADAD]' : !selectedDate, 'text-primary-blue' : selectedDate}">
        {{ "FORM.TERMINAL_LABEL" | transloco }}
      </p>
      <p class="text-sm break-words"
        [ngClass]="{'text-[#ADADAD]' : !selectedTerminal, 'text-black' : selectedTerminal}">
        @if(selectedTerminal) {
        {{selectedTerminal.terminalName}}
        }@else {
        {{ "FORM.TERMINAL_PLACEHOLDER" | transloco }}
        }
      </p>
    </div>
    }
    <mat-menu #terminalMenu="matMenu" class="h-full max-h-80 max-width-initial">
      @for (terminal of arrivalTerminals; track $index) {
      <button mat-menu-item (click)="setTerminal(terminal)">
        <span>{{terminal.terminalName}}</span>
      </button>
      }
    </mat-menu>
    }

    @if(!showHotel) {
    <div class="border-l gap- border-color-gray"></div>
    }

    @if(!showHotel && type==='departure') {

    <div [matMenuTriggerFor]="shuttleBusTime"
      class="flex-1 cursor-pointer py-4 px-4 lg:py-0 lg:px-0 lg:pl-6 border-style rounded-[16px] border lg:border-none"
      [ngClass]="{
                'pointer-events-none' : !(selectedTerminal || selectedFlight),
                'cursor-not-allowed' : !(selectedTerminal || selectedFlight)
                }" (click)="fetchDepShuttleBusses('departure')">
      <p [ngClass]="{'text-[#ADADAD]' : !(selectedTerminal || selectedFlight), 'text-primary-blue' : (selectedTerminal || selectedFlight)}"
        class="font-bold text-sm pb-2 break-words">
        {{"FORM.PICKUPTIME" | transloco}}
      </p>
      <p class="text-sm break-words" [ngClass]="{
                 'text-[#ADADAD]' : !selectedShuttleBusDeparture,
                 'text-black' : selectedShuttleBusDeparture
             }">
        @if(selectedShuttleBusDeparture) {
        {{selectedShuttleBusDeparture.startDate | date: 'yyyy-MM-dd'}}
        {{' ' + ("PARKIFLY.CLOCK_SHORT" | transloco)}}: {{selectedShuttleBusDeparture.startDate | date:
        'HH:mm'}}
        }@else {
        {{"FORM.PICKUP_TIME_PLACEHOLDER" | transloco}}
        }
      </p>
    </div>
    <mat-menu #shuttleBusTime="matMenu" class="h-full max-h-80 max-width-initial">
      @for (route of plannedShuttleBussesDeparture; track $index) {
      <button mat-menu-item (click)="setShuttleBus(route,'departure')">
        <div class="display-flex">
          <span>{{("PARKIFLY.CLOCK_SHORT" | transloco)}}: {{route.startDate | date: 'HH:mm'}}</span>
          <div class="width-5"></div>
          @if (route.seats != null) {
          <span>{{'QUALITY_HOTEL.AVAILABLE_SPOTS' | transloco}}({{(route.seats -
            route.passengers)}})</span>
          }
        </div>
      </button>
      }
    </mat-menu>

    <div class="border-l gap- border-color-gray"></div>

    <div
      class="flex-1 cursor-pointer-none py-4 px-4 lg:py-0 lg:px-0 lg:pl-6 border-style rounded-[16px] border lg:border-none">
      <div class="flex w-full gap-2">
        <div class="min-w-0">
          <p class="font-bold text-primary-blue text-sm pb-2 break-words"
            [ngClass]="{'text-[#ADADAD]' : !selectedShuttleBusDeparture, 'text-primary-blue' : selectedShuttleBusDeparture}">
            {{"QUALITY_HOTEL.PARKING_START_DATE" | transloco}}
          </p>
          <p class="text-sm break-words" [ngClass]="{
                 'text-[#ADADAD]' : !parkingStartDate,
                 'text-black' : parkingStartDate}">
            @if(parkingStartDate) {
            {{parkingStartDate | date : 'yyyy-MM-dd' }}
            {{' ' + ("PARKIFLY.CLOCK_SHORT" | transloco)}}:
            {{parkingStartDate | date : 'HH:mm' }}
            } @else {
            {{"QUALITY_HOTEL.PARKING_START_DATE_LABEL" | transloco}}
            }
          </p>
        </div>
      </div>
    </div>

    }

    @if(!showHotel && type==='arrival') {

    @if (type === 'arrival') {
    <div [matMenuTriggerFor]="shuttleBusTimeForArrival"
      class="flex-1 cursor-pointer py-4 px-4 lg:py-0 lg:px-0 lg:pl-6 border-style rounded-[16px] border lg:border-none"
      [ngClass]="{
                'pointer-events-none' : !(selectedFlight || selectedTerminal),
                'cursor-not-allowed' : !(selectedFlight || selectedTerminal)
                }" (click)="fetchArrShuttleBusses('departure')">
      <p [ngClass]="{'text-[#ADADAD]' : !(selectedFlight || selectedTerminal), 'text-primary-blue' : (selectedFlight || selectedTerminal)}"
        class="font-bold text-sm pb-2 break-words">
        {{"FORM.PICKUPTIME" | transloco}}
      </p>
      <p class="text-sm break-words" [ngClass]="{
                 'text-[#ADADAD]' : !selectedShuttleBusArrival,
                 'text-black' : selectedShuttleBusArrival
             }">
        @if(selectedShuttleBusArrival) {
        {{selectedShuttleBusArrival.startDate | date: 'yyyy-MM-dd'}}
        {{' ' + ("PARKIFLY.CLOCK_SHORT" | transloco)}}: {{selectedShuttleBusArrival.startDate | date: 'HH:mm'}}
        }@else {
        {{"FORM.PICKUP_TIME_PLACEHOLDER" | transloco}}
        }
      </p>
    </div>
    }

    <mat-menu #shuttleBusTimeForArrival="matMenu" class="h-full max-h-80 max-width-initial">
      @for (route of plannedShuttleBussesArrival; track $index) {
      <button mat-menu-item (click)="setShuttleBus(route, 'arrival')">
        <div class="display-flex">
          <span>{{("PARKIFLY.CLOCK_SHORT" | transloco)}}: {{route.startDate | date: 'HH:mm'}}</span>
          <div class="width-5"></div>
          @if (route.seats != null) {
          <span>{{'QUALITY_HOTEL.AVAILABLE_SPOTS' | transloco}}({{(route.seats -
            route.passengers)}})</span>
          }
        </div>
      </button>
      }
    </mat-menu>
    }
  </div>

  <!-- info text-->
  @if(showHotel) {
  <p class="flex gap-[10px] text-sm">
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 2.375C8.39303 2.375 6.82214 2.85152 5.486 3.74431C4.14985 4.6371 3.10844 5.90605 2.49348 7.3907C1.87852 8.87535 1.71762 10.509 2.03112 12.0851C2.34463 13.6612 3.11846 15.1089 4.25476 16.2452C5.39106 17.3815 6.8388 18.1554 8.4149 18.4689C9.99099 18.7824 11.6247 18.6215 13.1093 18.0065C14.594 17.3916 15.8629 16.3502 16.7557 15.014C17.6485 13.6779 18.125 12.107 18.125 10.5C18.1227 8.34581 17.266 6.28051 15.7427 4.75727C14.2195 3.23403 12.1542 2.37727 10 2.375ZM9.6875 6.125C9.87292 6.125 10.0542 6.17998 10.2084 6.283C10.3625 6.38601 10.4827 6.53243 10.5536 6.70373C10.6246 6.87504 10.6432 7.06354 10.607 7.2454C10.5708 7.42725 10.4815 7.5943 10.3504 7.72541C10.2193 7.85652 10.0523 7.94581 9.8704 7.98199C9.68854 8.01816 9.50004 7.99959 9.32874 7.92864C9.15743 7.85768 9.01101 7.73752 8.908 7.58335C8.80499 7.42918 8.75 7.24792 8.75 7.0625C8.75 6.81386 8.84878 6.5754 9.02459 6.39959C9.20041 6.22377 9.43886 6.125 9.6875 6.125ZM10.625 14.875C10.2935 14.875 9.97554 14.7433 9.74112 14.5089C9.5067 14.2745 9.375 13.9565 9.375 13.625V10.5C9.20924 10.5 9.05027 10.4342 8.93306 10.3169C8.81585 10.1997 8.75 10.0408 8.75 9.875C8.75 9.70924 8.81585 9.55027 8.93306 9.43306C9.05027 9.31585 9.20924 9.25 9.375 9.25C9.70652 9.25 10.0245 9.3817 10.2589 9.61612C10.4933 9.85054 10.625 10.1685 10.625 10.5V13.625C10.7908 13.625 10.9497 13.6908 11.0669 13.8081C11.1842 13.9253 11.25 14.0842 11.25 14.25C11.25 14.4158 11.1842 14.5747 11.0669 14.6919C10.9497 14.8092 10.7908 14.875 10.625 14.875Z"
        fill="#0040DD" />
    </svg>
    <span>
      @if(type === 'arrival') {
      {{"PARKIFLY.SEARCH.ARRIVAL_HOTEL_INFO" | transloco}}
      }
      @if(type === 'departure') {
      {{"PARKIFLY.SEARCH.DEPARTURE_HOTEL_INFO_QUALITY" | transloco}}
      }
    </span>
  </p>
  }@else {
  @if(type === 'arrival' && useFlightForArrival) {
  <p class="flex gap-[10px] text-sm">
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 2.375C8.39303 2.375 6.82214 2.85152 5.486 3.74431C4.14985 4.6371 3.10844 5.90605 2.49348 7.3907C1.87852 8.87535 1.71762 10.509 2.03112 12.0851C2.34463 13.6612 3.11846 15.1089 4.25476 16.2452C5.39106 17.3815 6.8388 18.1554 8.4149 18.4689C9.99099 18.7824 11.6247 18.6215 13.1093 18.0065C14.594 17.3916 15.8629 16.3502 16.7557 15.014C17.6485 13.6779 18.125 12.107 18.125 10.5C18.1227 8.34581 17.266 6.28051 15.7427 4.75727C14.2195 3.23403 12.1542 2.37727 10 2.375ZM9.6875 6.125C9.87292 6.125 10.0542 6.17998 10.2084 6.283C10.3625 6.38601 10.4827 6.53243 10.5536 6.70373C10.6246 6.87504 10.6432 7.06354 10.607 7.2454C10.5708 7.42725 10.4815 7.5943 10.3504 7.72541C10.2193 7.85652 10.0523 7.94581 9.8704 7.98199C9.68854 8.01816 9.50004 7.99959 9.32874 7.92864C9.15743 7.85768 9.01101 7.73752 8.908 7.58335C8.80499 7.42918 8.75 7.24792 8.75 7.0625C8.75 6.81386 8.84878 6.5754 9.02459 6.39959C9.20041 6.22377 9.43886 6.125 9.6875 6.125ZM10.625 14.875C10.2935 14.875 9.97554 14.7433 9.74112 14.5089C9.5067 14.2745 9.375 13.9565 9.375 13.625V10.5C9.20924 10.5 9.05027 10.4342 8.93306 10.3169C8.81585 10.1997 8.75 10.0408 8.75 9.875C8.75 9.70924 8.81585 9.55027 8.93306 9.43306C9.05027 9.31585 9.20924 9.25 9.375 9.25C9.70652 9.25 10.0245 9.3817 10.2589 9.61612C10.4933 9.85054 10.625 10.1685 10.625 10.5V13.625C10.7908 13.625 10.9497 13.6908 11.0669 13.8081C11.1842 13.9253 11.25 14.0842 11.25 14.25C11.25 14.4158 11.1842 14.5747 11.0669 14.6919C10.9497 14.8092 10.7908 14.875 10.625 14.875Z"
        fill="#0040DD" />
    </svg>
    <span>
      {{"QUALITY_HOTEL.ARRIVAL_BY_FLIGHT_INFO" | transloco}}
    </span>
  </p>
  }
  }

  <!-- Switch/Toggle -->
  @if (type === 'arrival') {
  <div class="flex gap-4">
    @if (type === 'arrival') {
    <div class="relative  inline-block">
      <input (change)="toggleParkingEndDate()" type="checkbox" [checked]="showParkingEndDate"
        id="hs-default-switch-with-icons"
        class="peer relative w-[3.25rem] h-7 p-px bg-gray-100 border-transparent text-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:ring-blue-600 disabled:opacity-50 disabled:pointer-events-none checked:bg-none checked:text-toggle-success checked:border-toggle-success focus:checked:border-blue-600 dark:bg-neutral-800 dark:border-neutral-700 dark:checked:bg-blue-500 dark:checked:border-blue-500 dark:focus:ring-offset-gray-600 before:inline-block before:size-6 before:bg-white checked:before:bg-white before:translate-x-0 checked:before:translate-x-full before:rounded-full before:shadow before:transform before:ring-0 before:transition before:ease-in-out before:duration-200 dark:before:bg-neutral-400 dark:checked:before:bg-blue-200">
      <label for="hs-default-switch-with-icons" class="sr-only">switch</label>
      <span
        class="peer-checked:text-white text-gray-500 size-6 absolute top-0.5 start-0.5 flex justify-center items-center pointer-events-none transition-colors ease-in-out duration-200 dark:text-neutral-500">
        <svg class="flex-shrink-0 size-3" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M18 6 6 18"></path>
          <path d="m6 6 12 12"></path>
        </svg>
      </span>
      <span
        class="peer-checked:text-success text-gray-500 size-6 absolute top-0.5 end-0.5 flex justify-center items-center pointer-events-none transition-colors ease-in-out duration-200 dark:text-neutral-500">
        <svg class="flex-shrink-0 size-3" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      </span>
    </div>
    }
    <p class="self-center font-medium text-sm leading-none break-words">
      {{"QUALITY_HOTEL.HOTEL_ARRIVAL_TOGGLE_LABEL" | transloco: {hotelName: hotelName}
      }}
    </p>
  </div>
  }

  <!-- parking end date time -->
  @if (type === 'arrival' && showParkingEndDate) {
  <div
    class="flex flex-col lg:flex-row h-auto lg:h-[80px] py-[15px] lg:border lg:border-[#AAAAAA] rounded-[5px]; lg:rounded-[16px] gap-1 truncate">
    <div (click)="openHotelDateTimeDialog('parkingEnd')"
      class="flex-1 cursor-pointer py-4 px-4 lg:py-0 lg:px-0 lg:pl-6 border-style rounded-[16px] border lg:border-none">
      <div class="flex w-full gap-2">
        <div class="min-w-0 flex-1">
          <p class="font-bold text-sm text-primary-blue pb-2 break-all">
            {{"FORM.PARKING_END_LABEL" | transloco}}
          </p>
          <p class="text-sm break-all"
            [ngClass]="{'text-[#717171]' : !selectedParkingEndDate, 'text-black' : selectedParkingEndDate}">
            @if(selectedParkingEndDate) {
            {{selectedParkingEndDate | date : 'yyyy-MM-dd' }}
            {{' ' + ("PARKIFLY.CLOCK_SHORT" | transloco)}}:
            {{selectedParkingEndDate | date : 'HH:mm' }}
            }@else {
            {{"FORM.PARKING_END_PLACEHOLDER" | transloco}}
            }
          </p>
        </div>
      </div>
    </div>
  </div>
  }

</div>